import { createContext, useState } from 'react'

import type { MenuCollapseContextProps, MenuCollapseProviderProps } from './types'

export const MenuCollapseContext = createContext<MenuCollapseContextProps>(
  {} as MenuCollapseContextProps
)

export const MenuCollapseProvider = ({ children }: MenuCollapseProviderProps) => {
  const [communitiesLength, setCommunitiesLength] = useState<number>(0)
  const [groupCommunitiesLength, setGroupCommunitiesLength] = useState<number>(0)

  return (
    <MenuCollapseContext.Provider
      value={{
        communitiesLength,
        groupCommunitiesLength,
        setCommunitiesLength,
        setGroupCommunitiesLength
      }}>
      {children}
    </MenuCollapseContext.Provider>
  )
}
